import { render, staticRenderFns } from "./SidebarItem.ts.vue?vue&type=template&id=47e2998d"
import script from "./SidebarItem.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarItem.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarItem.ts.vue?vue&type=style&index=0&id=47e2998d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports